/**
 * Affichée dans `container` à la place de `#map` quand `loadInitialData` échoue (voir
 * `createTokaMap.ts`, BESOINS.md §8) — message d'erreur + bouton "Réessayer" qui relance le
 * chargement. Vit dans `@tokamap/core`, pas côté consommateur : afficher/retenter un chargement
 * raté est un comportement générique de l'outil (CLAUDE.md), pas quelque chose que chaque
 * application consommatrice devrait réimplémenter elle-même.
 */
export class LoadErrorView {
  private element: HTMLDivElement | null = null;

  constructor(private container: HTMLElement) {}

  /** Affiche l'erreur ; résout quand l'utilisateur clique "Réessayer" (démontée juste avant). */
  show(error: unknown): Promise<void> {
    this.close();

    return new Promise<void>((resolve) => {
      const root = document.createElement("div");
      root.className = "toka-load-error";

      const title = document.createElement("p");
      title.className = "toka-load-error__title";
      title.textContent = "Impossible de charger la carte";
      root.appendChild(title);

      const message = document.createElement("p");
      message.className = "toka-load-error__message";
      message.textContent = error instanceof Error ? error.message : String(error);
      root.appendChild(message);

      const retryButton = document.createElement("button");
      retryButton.type = "button";
      retryButton.className = "toka-load-error__retry";
      retryButton.textContent = "Réessayer";
      retryButton.addEventListener("click", () => {
        this.close();
        resolve();
      });
      root.appendChild(retryButton);

      this.container.appendChild(root);
      this.element = root;
    });
  }

  close(): void {
    this.element?.remove();
    this.element = null;
  }
}
